import axios from '@axios'

const route = 'stock/purchase_entry'

export default {
  namespaced: true,
  state: {
    order: {},
    orders: [],
    entries: [],
    products: [],
    supplier: {},
    deliveryDate: '',
    addressee: {},
    taxes: [],
    observations: '',
    conclusion: {},
    parcels: [],

    // step: 'select_supplier', //select_supplier ; order_details ; conclusion
    step_number: 1,
  },
  getters: {
    /**
     *retona o pedido de compra para editar
     */
    getOrder(state) {
      return state.order
    },

    /**
     * retorna os pedidos de compra da tabela principal
     */
    getEntries(state) {
      return state.orders
    },

    /**
     *  retorna as observações do pedido de compra
     */
    getObservations(state) {
      return state.observations
    },

    /**
     *retorna ao endereco do destinatario
     */
    getAddressee(state) {
      return state.addressee
    },

    /**
     * retorna os dados de conclusão do pedido de compra
     */
    getConclusion(state) {
      return state.conclusion
    },

    /**
     * retone as taxas do pedido de compra
     */
    getTaxes(state) {
      return state.taxes
    },

    /**
     * retorna a data de entrega do pedido de compra
     */
    getDeliveryDate(state) {
      return state.deliveryDate
    },

    /**
     * retorna o numero do passo atual do pedido de compra
     */
    getStepNumber(state) {
      return state.step_number
    },

    /**
     * retorna os produtos do pedido de compra
     */
    getProducts(state) {
      state.products.forEach(element => {
        element.total_cost = parseFloat(element.quantity_received || 0) * parseFloat(element.unit_cost)
      })

      return state.products
    },

    /**
     *  retorna o fornecedor do pedido de compra
     */
    getSupplier(state) {
      return state.supplier
    },

    /**
     * retorna o passo atual do pedido de compra
     */
    getStep(state) {
      return state.step
    },

    /**
     * retorna o sub total
     */
    getSubtotal(state) {
      return state.products.reduce((sum, item) => sum + parseFloat(item.quantity_to_receive || 0) * parseFloat(item.unit_cost || 0), 0)
    },

    /**
     * retorna a soma das taxas
     */
    getSumTaxes(state) {
      return state.taxes.reduce((sum, tax) => sum + parseFloat(tax.value), 0)
    },

    getTotal(context, getters) {
      return getters.getSubtotal + getters.getSumTaxes
    },

    /**
     * retorna as parcelas do pedido de compra
     */
    getParcels(state) {
      return state.parcels
    },
  },
  mutations: {
    /**
     * seta as parcelas
     */
    setParcels(state, parcels) {
      state.parcels = parcels
    },

    /**
     * define o pedido de compra para editar
     */
    setOrder(state, order) {
      state.order = order
    },

    /**
     * define os pedidos de compra da tabela principal
     */
    setEntries(state, orders) {
      state.orders = orders
    },

    /**
     * define as observações do pedido de compra
     */
    setObservations(state, observations) {
      state.observations = observations
    },

    /**
     * define o endereco do destinatario
     */
    setAddressee(state, addresse) {
      state.addressee = addresse
    },

    /**
     * define os dados de conclusão do pedido de compra
     */
    setConclusion(state, conclusion) {
      state.conclusion = conclusion
    },

    /*
     * define as taxas do pedido de compra
     */
    setTaxes(state, taxes) {
      state.taxes = taxes
    },

    /**
     * define a data de entrega do pedido de compra
     */
    setDeliveryDate(state, deliveryDate) {
      state.deliveryDate = deliveryDate
    },

    /**
     * define o numero do passo atual do pedido de compra
     */
    setStepNumber(state, step_number) {
      state.step_number = step_number
    },

    /**
     * define os produtos do pedido de compra
     */
    setProducts(state, products) {
      state.products = products
    },

    /**
     * define o fornecedor do pedido de compra
     */
    setSupplier(state, supplier) {
      state.supplier = supplier
    },

    /**
     * define o passo atual do pedido de compra
     */
    setStep(state, step) {
      state.step = step
    },

    /*
     * limpa os dados do pedido de compra
     */
    setClear(state) {
      state.order = {}
      state.supplier = {}
      state.products = []
      state.taxes = []
      state.observations = ''
      state.addressee = {}
      state.deliveryDate = ''
      state.conclusion = {}
      state.step = 'select_supplier'
      state.step_number = 1
    },
  },
  actions: {
    index(context, {
      itemsPerPage, page, search, filter, sortBy,
    }) {
      return axios.post(
        `${route}/index?page=${page}&items_per_page=${itemsPerPage}&search=${search}&sort_by=${sortBy}`,
        filter,
      )
    },

    /**
     *  exportar pdf de recebimento de estoque
     */
    exportPdfReceived(context, purchaseEntryId) {
      return axios
        .get(`${'stock/purchase_entry' + '/export_pdf_receive/'}${purchaseEntryId}`, {
          responseType: 'blob',
        })
        .catch(() => {})
        .finally(() => {})
    },

    /**
     * recebe o pedido de compra
     */
    receiveStock(context) {
      const receiveData = {
        purchase_order_id: context.state.order.id,
        supplier: context.state.supplier,
        addressee: context.state.addressee,
        products: context.state.products,
        taxes: context.state.taxes,
        observations: context.state.observations,
        subtotal: context.getters.getSubtotal,
        sum_taxes: context.getters.getSumTaxes,
        total: context.getters.getTotal,
        status: context.state.order.status,
        parcels: context.state.parcels,
      }

      return axios.post('stock/purchase_entry', receiveData)
    },

    /**
     * cancelar compra
     */
    cancelPurchase(context, purchaseEntryId) {
      return axios.post(`stock/purchase_entry/cancel_purchase/${purchaseEntryId}`)
    },
  },
}
